import { render, staticRenderFns } from "./ProjectsExpenses.vue?vue&type=template&id=30380af3"
import script from "./ProjectsExpenses.vue?vue&type=script&lang=js"
export * from "./ProjectsExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports